import { type ValueOf } from 'type-fest';

import { CoreProductGeneralFilters } from '../core-product-filters';
import { type HandledCoreProductGeneralFilterDimensionAttributePaths } from '../CoreGeneralFilters.types';

export const CORE_PRODUCT_GENERAL_FILTER_MAP: Record<
  HandledCoreProductGeneralFilterDimensionAttributePaths,
  ValueOf<typeof CoreProductGeneralFilters>
> = {
  'product.products': CoreProductGeneralFilters.Product,
  'product.departments': CoreProductGeneralFilters.Department,
  'product.sub_departments': CoreProductGeneralFilters.SubDepartment,
  'product.seasons': CoreProductGeneralFilters.Season,
  'product.events': CoreProductGeneralFilters.Event,
  'product.brands': CoreProductGeneralFilters.Brand,
  'product.collection_types': CoreProductGeneralFilters.CollectionType,
  'product.season_events': CoreProductGeneralFilters.SeasonEvent,
  'product.classes': CoreProductGeneralFilters.Class,
  'product.sub_classes': CoreProductGeneralFilters.SubClass,
  'product.budget_levels': CoreProductGeneralFilters.BudgetLevel,
  'product.articles': CoreProductGeneralFilters.Article,
  'product.manufacturers': CoreProductGeneralFilters.Manufacturer,
  'product_groups.groups': CoreProductGeneralFilters.ProductGroups,
  'product.materials': CoreProductGeneralFilters.Material,
  'product.styles': CoreProductGeneralFilters.Style,
  'product.colors': CoreProductGeneralFilters.Color,
  'product.genders': CoreProductGeneralFilters.Gender,
  'sku.sku_ids': CoreProductGeneralFilters.Sku,
  'size.sizes': CoreProductGeneralFilters.Size,
  'size_run.size_runs': CoreProductGeneralFilters.SizeRun,
};
